import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.573 10.226h2.202v2.202c0 1.007.816 1.823 1.823 1.823h4.83a1.823 1.823 0 0 0 1.823-1.823v-4.83a1.823 1.823 0 0 0-1.823-1.823h-2.202V3.573A1.823 1.823 0 0 0 8.403 1.75h-4.83A1.823 1.823 0 0 0 1.75 3.573v4.83c0 1.007.816 1.823 1.823 1.823m8.855-2.951h-2.202v1.128a1.823 1.823 0 0 1-1.823 1.823H7.275v2.202c0 .178.145.323.323.323h4.83a.323.323 0 0 0 .323-.323v-4.83a.323.323 0 0 0-.323-.323",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }